module.exports = __webpack_public_path__ + "img/logo_blue.d79fd7a2.png";